export default "__VITE_ASSET__Bisrvz0I__"